/**
 * The URL a visitor was trying to reach when `SessionGate` sent them to sign-in. Held in a
 * module variable rather than a query parameter because the URL-state registry
 * (`src/routes/urlState.ts`) is closed.
 */
let pending: string | null = null;

export function setPendingPath(path: string | null): void {
  pending = path;
}

/** Reads the attempted URL and clears it. */
export function takePendingPath(): string | null {
  const value = pending;
  pending = null;
  return value;
}
